module.exports = __webpack_public_path__ + "static/img/1043_small.8ad3c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1043_small.png
// module id = XU+o
// module chunks = 1